export function checkStatus (response) {
    if (response.ok) {
        return response;
    }
    // implicit else, as hasn’t returned
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
}

export function parseJSON (response) {
    return response.json();
}

export function parseText (response) {
    return response.text();
}

export function postJSON (url) {
    return fetch(url, {
        method: 'POST',
        credentials: 'same-origin'
    })
        .then(checkStatus)
        .then(parseJSON);
}

export function fetchJSON (url) {
    return fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
        credentials: 'same-origin'
    })
        .then(checkStatus)
        .then(parseJSON);
}
